import React from 'react'
import HTML from '../assets/html.png'
import CSS from '../assets/css.png'
import Javascript from '../assets/javascript.png'
import ReactImg from '../assets/react.png'
import Node from '../assets/node.png'
import GitHub from '../assets/github.png'
import C from '../assets/c++.png'
import Python from '../assets/python.png'

const Skills = () => {
  return (
    <div name='skills' className='w-full h-screen bg-[#0a192f] text-gray-300'  >
       {/* Container */}
       <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full' >
        <div>
            <p className='text-4xl font-bold inline border-b-4 border-green-600'>Skills</p>
            <p className='py-4' >A list of Technologies I have worked with</p>
        </div>
        <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8' >
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500' >
                <img className='w-20 mx-auto'  src={HTML} alt="HTML icon" />
                <p className='my-4' >HTML5</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={CSS} alt="CSS icon" />
                <p className='my-4' >CSS3</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={Javascript} alt="Javascript icon" />
                <p className='my-4' >Javascript</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={ReactImg} alt="React icon" />
                <p className='my-4' >React</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={Node} alt="node icon" />
                <p className='my-4' >Node.js</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={GitHub} alt="Github icon" />
                <p className='my-4' >Github</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={C} alt="C++ icon" />
                <p className='my-4' >C++</p>
            </div>
            <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500 ' >
                <img className='w-20 mx-auto'  src={Python} alt="Python icon" />
                <p className='my-4' >Python</p>
            </div>
        </div>
    </div>
</div>

  )
}

export default Skills